<template>
  <div class="evaluation-answer-slider">
    <el-slider
      v-model="internalValue"
      input-size="large"
      @change="onChange"
      :max="question.$answers.length - 1"
      :show-stops="true"
      :format-tooltip="tooltipLabel"
      :disabled="disabled"
    />
    <p>
      <b>Respuesta:</b> {{ question.$answers[internalValue].name }}
    </p>

  </div>
</template>

////////////////////////////
//                   SCRIPT
////////////////////////////
<script>
export default {
  name: 'EvaluationAnswerSlider',
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    question: {
      type: Object,
      required: true
    },
    branchType: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      internalValue: 0
    }
  },
  mounted () {
    this.calculateBaseScore()
    if (!this.question.$result) {
      let answer = this.question.$answers[0]
      this.question.$result = answer.$id
      if (answer.$pointsPerBranch) {
        for (let branchPoints of answer.$branchPoints) {
          if (branchPoints.type === this.branchType) {
            this.question.$points = branchPoints.points
            break
          }
        }
      } else {
        this.question.$points = this.question.$answers[0].$points
      }
    } else {
      for (let i = 0; i < this.question.$answers.length; i++) {
        console.log(this.question.$answers[i].$id, 'vs', this.question.$result)
        if (this.question.$answers[i].$id === this.question.$result) {
          this.internalValue = i
          break
        }
      }
    }
  },
  methods: {
    calculateBaseScore () {
      this.question.$baseScore = 0
      for (let answer of this.question.$answers) {
        if (answer.$pointsPerBranch) {
          for (let branchPoints of answer.$branchPoints) {
            if (branchPoints.type === this.branchType) {
              if (this.question.$baseScore < branchPoints.points) {
                this.question.$baseScore = branchPoints.points
              }
            }
          }
        } else {
          if (this.question.$baseScore < answer.$points) {
            this.question.$baseScore = answer.$points
          }
        }
      }
    },
    onChange (index) {
      let answer = this.question.$answers[index]
      this.question.$result = this.question.$answers[this.internalValue].$id
      this.$set(
        this.question,
        'innerEvidenceRequired',
        this.question.$answers[this.internalValue].$evidenceRequired
      )
      if (answer.$pointsPerBranch) {
        console.log(answer)
        for (let branchPoints of answer.$branchPoints) {
          if (branchPoints.type === this.branchType) {
            this.question.$points = branchPoints.points
            break
          }
        }
      } else {
        this.question.$points = answer.$points
      }
    },
    tooltipLabel (index) {
      return this.question.$answers[index]
        ? this.question.$answers[index].name
        : null
    }
  }
}
</script>

////////////////////////////
//                    STYLE
////////////////////////////
<style
  lang="scss"
  scoped
>
.evauation-answer-slider {
}
</style>



// WEBPACK FOOTER //
// src/modules/evaluation/components/answers/evaluation-answer-slider.vue